import React from 'react';
import ShowMiscellanyOrderCategoriesProperties from "./ShowMiscellanyOrderCategoriesProperties";
import {useStyles} from "./ShowMiscellanyOrderCategories.style";
import clsx from "clsx";

const ShowMiscellanyOrderCategories: React.FC<ShowMiscellanyOrderCategoriesProperties> = ({
                                                        categories,
                                                        className = '',
                                                  }) => {

    const classes = useStyles();

    return (
        <div className={clsx(classes.show_price_container, className)}>
            <div>
                <div className={classes.number}>
                    <div className={classes.title}>{`Categorias (${categories.length}):`}</div>
                    <div className={classes.value}>
                        {categories.map((category, index) => (
                            <span>{category.miscellanyCategoryName} ({category.amount}){index < categories.length - 1 && <span>,</span>} </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}


export default ShowMiscellanyOrderCategories;